module.exports = __webpack_public_path__ + "img/slide_5.7c4544fb.webp";